import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { PaginationProps } from './Pagination.types';
import './Pagination.scss';

const buildRange = (page: number, total: number, siblings: number): (number | 'gap')[] => {
  const range: (number | 'gap')[] = [];
  const start = Math.max(2, page - siblings);
  const end = Math.min(total - 1, page + siblings);
  range.push(1);
  if (start > 2) range.push('gap');
  for (let i = start; i <= end; i++) range.push(i);
  if (end < total - 1) range.push('gap');
  if (total > 1) range.push(total);
  return range;
};

export default function Pagination({ page, total, onChange, siblings = 1, className }: PaginationProps) {
  if (total <= 1) return null;
  const range = buildRange(page, total, siblings);
  const prev = () => page > 1 && onChange(page - 1);
  const next = () => page < total && onChange(page + 1);

  return (
    <nav aria-label="Пагинация" className={['pagination', className || ''].filter(Boolean).join(' ')}>
      <button type="button" aria-label="Назад" className="pagination__btn" disabled={page <= 1} onClick={prev}>
        <ChevronLeft size={16} />
      </button>
      <div className="pagination__pages">
        {range.map((it, i) => it === 'gap'
          ? <span key={`g-${i}`} className="pagination__gap" aria-hidden="true">…</span>
          : (
            <button
              key={it}
              type="button"
              aria-current={it === page ? 'page' : undefined}
              className={['pagination__btn', it === page ? 'pagination__btn--active' : ''].filter(Boolean).join(' ')}
              onClick={() => onChange(it)}
            >
              {it}
            </button>
          ))}
      </div>
      <div className="pagination__compact" aria-live="polite">{page} / {total}</div>
      <button type="button" aria-label="Вперёд" className="pagination__btn" disabled={page >= total} onClick={next}>
        <ChevronRight size={16} />
      </button>
    </nav>
  );
}
